// TODO: [#defaultStyles] we need to move all default styles to 1 place
export const DEFAULT_ARTBOARD_BACKGROUND = '#EFEFEF';
export const DefaultBackgroundColor = '#FFFFFF';
export const DefaultBorderColor = '#000000';
export const DefaultCallToActionBackgroundColor = '#F6F6F6';
export const DefaultCallToActionFontColor = '#2B2B2B';
export const DefaultThumbnailBorderColor = '#000000';

export const colorTints = [0, 20, 60, 80, 90, 95];
